export default class HandoverItemsModel {
    HandoverItemId: number;
    HandoverItemType: string;
    HandoverItemTitle: string;
    Description: string;
}
